<div mat-dialog-content>
  <lemon-dialog-header> Kutsu uusi tilintarkastaja </lemon-dialog-header>

  <div style="font-size: 12px; color: gray; margin-bottom: 15px">
    Tarkistathan tilintarkastajan nimi- ja sähköpostiosoitteen huolellisesti ennen kutsun lähettämistä.
    <br />
    <br />
    Tilintarkastajalle lähetetään sähköposti, joka sisältää taikalinkin. Linkin kautta tilintarkastaja voi tunnistautua Lemonatoriin pankkitunnuksin. Tilintarkastajan henkilöllisyys vahvistetaan, kun hän kirjautuu järjestelmään pankkitunnuksin.
    <br />
    <br />
    Voit asettaa tilintarkastajan tilinpäätökselle, kun olet lähettänyt kutsun.
  </div>

  <div style="display: flex; flex-direction: column">
    <mat-form-field>
      <mat-label>Etunimi</mat-label>
      <input matInput [formField]="lomake.etunimi" />
      @if (onkoVirhe(lomake.etunimi, 'required')) {
        <mat-error> Etunimi on pakollinen </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Sukunimi</mat-label>
      <input matInput [formField]="lomake.sukunimi" />
      @if (onkoVirhe(lomake.sukunimi, 'required')) {
        <mat-error> Sukunimi on pakollinen </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Sähköposti</mat-label>
      <input matInput type="email" [formField]="lomake.sahkoposti" />
      @if (onkoVirhe(lomake.sahkoposti, 'required')) {
        <mat-error> Sähköposti on pakollinen </mat-error>
      }
      @if (onkoVirhe(lomake.sahkoposti, 'email')) {
        <mat-error> Virheellinen sähköpostiosoite </mat-error>
      }
    </mat-form-field>

    <mat-form-field style="margin-top: 8px">
      <mat-label>Kutsusähköpostin aihe</mat-label>
      <input matInput [formField]="lomake.kutsuAihe" />
      @if (onkoVirhe(lomake.kutsuAihe, 'required')) {
        <mat-error> Aihe on pakollinen </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="no-outline no-margin">
      <textarea matInput [formField]="lomake.kutsuViestiYla" cdkTextareaAutosize [cdkAutosizeMinRows]="1" placeholder="Kirjoita viestin alku tähän"></textarea>
    </mat-form-field>

    <div style="white-space: pre-wrap">{{ TILINTARKASTAJA_KUTSU_VIESTIN_SISALTO_TAIKALINKKI }}</div>

    <mat-form-field class="no-outline no-margin">
      <textarea matInput [formField]="lomake.kutsuViestiAla" cdkTextareaAutosize [cdkAutosizeMinRows]="1"></textarea>
    </mat-form-field>
  </div>

  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <button mat-button mat-dialog-close class="secondarybutton">Peruuta</button>
    <button mat-button class="primarybutton" (click)="lahetaKutsu()" [disabled]="lomake().invalid()">Lähetä kutsu</button>
  </div>
</div>
